import { render } from "./TemplateSelector.vue?vue&type=template&id=4daec732&scoped=true"
import script from "./TemplateSelector.vue?vue&type=script&lang=ts"
export * from "./TemplateSelector.vue?vue&type=script&lang=ts"

import "./TemplateSelector.vue?vue&type=style&index=0&id=4daec732&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4daec732"

export default script